import json from './hanger.json';
import $ from 'jquery';
import lottie from 'lottie-web';

import '../../../images/animations/hanger/img_0.png';
import '../../../images/animations/hanger/img_1.png';
import '../../../images/animations/hanger/img_2.png';
import '../../../images/animations/hanger/img_3.png';

const defoptions = {
  renderer: 'svg',
  loop: true,
  autoplay: true,
  animationData: json,
  assetsPath: 'src/images/animations/hanger/'
};

//start hanger animations
$('.hanger').each(function(i,elem){
  let options = Object.assign({}, {'container': elem}, defoptions);
  lottie.loadAnimation(options);
});
